import axios from 'axios'

const setAuthToken = (token, sistema) => {
    if (sistema == "defis") {
        if (token) {
            axios.defaults.headers.common['x-auth-token'] = token
        } else {
            delete axios.defaults.headers.common['x-auth-token']
        }
    }
    else if (sistema == "etica") {
        if (token) {
            axios.defaults.headers.common['y-auth-token'] = token
        } else {
            delete axios.defaults.headers.common['y-auth-token']
        }
    }
    else if (sistema == "juridico") {
        if (token) {
            axios.defaults.headers.common['j-auth-token'] = token
        } else {
            delete axios.defaults.headers.common['j-auth-token']
        }
    }
}

export default setAuthToken